module.exports = __webpack_public_path__ + "static/media/editmode_cancel.97f2f617.svg";